<template>
  <dashboard-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        ref="form"
        :data-url="
          selectedUrl
            ? selectedUrl
            : '/evaluator/pendingAssignments/evaluationTeam'
        "
      >
        <table class="table table-sm table-striped text-center">
          <thead>
            <tr>
              <th scope="col">FUNCION</th>
              <th scope="col">EQUIPO EVALUADOR</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in evaluatorTeam" :key="key">
              <td>{{ value.evaluator.evaluator_type.value }}</td>
              <td>{{ value.evaluator.full_name }}</td>
            </tr>
          </tbody>
        </table>
        <div class="row">
          <div class="col-12">
            <div class="form-group row align-items-center">
              <label class="col-9 pt-2"> Confirmar Asistencia </label>
              <app-input
                class="col-3"
                type="radio-buttons"
                :list="list"
                v-model="inputs.is_confirmed"
              />
            </div>
          </div>
        </div>
      </form>
    </template>
  </dashboard-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
    modalId: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      list: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
      evaluatorTeam: [],
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.save(this.inputs);
    },
    afterSuccess(response) {
      // this.$toastr.s(response.data.message);
      this.inputs = response.data;
      this.$toastr.s(this.$t("created_success"));
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data.inputs;
      this.evaluatorTeam = response.data.evaluatorTeam;
      this.preloader = false;
    },
  },
};
</script>
